
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ReferralTerms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 transition-colors min-h-[48px] touch-manipulation"
        >
          <ArrowLeft size={16} />
          Back to Home
        </Link>
        
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">ZimKonnect Referral Program Terms</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8">
          <p className="text-sm text-gray-500 mb-6">Effective Date: July 2025</p>
          
          <p className="text-gray-700 mb-6 leading-relaxed">
            By joining our referral program, you agree to the terms below:
          </p>

          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3">1. Eligibility</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-1">
                <li>Referrers must be 18+</li>
                <li>Must have a verified ZimKonnect account</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3">2. How It Works</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-1">
                <li>Share your custom referral link</li>
                <li>Earn rewards (coming soon) when new users join via your link and activate an account</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3">3. Rewards System</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-1">
                <li>Rewards may include discounts, credits, or partner bonuses</li>
                <li>Referral bonuses are not guaranteed and depend on platform activity</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3">4. Abuse & Fraud</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-1">
                <li>ZimKonnect reserves the right to cancel any referral if abuse or fraud is suspected</li>
                <li>Multiple signups from the same IP or false projects will be flagged</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3">5. Changes to Program</h2>
              <p className="text-gray-700">
                ZimKonnect may change or terminate the program at any time without notice.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralTerms;
